import { PropsWithChildren } from 'react';

const ModalBody: React.FunctionComponent<PropsWithChildren> = ({
  children,
}): JSX.Element => {
  return <div className="mt-6 px-8 text-sm">{children}</div>;
};

export default ModalBody;
